// @flow
import get from 'lodash/get'
import { List } from 'immutable'
import { browserName } from 'react-device-detect'

import * as types from './actionTypes'
import { createRequestActions } from 'helpers'
import { createAction } from 'redux-actions'
import { createRequestActions as request } from '../../actionCreators/createRequestActions'
import { ORGANIZATIONS_EDIT_FORM_NAME } from 'app/constants/organizations'

export const adminOrganizationUsersResendProtracks = request('ADMIN_ORGANIZATION_USERS_RESEND_PROTRACKS', userData => ({
  request: {
    url: '/users/select-protrack-resend',
    method: 'POST',
    data: userData,
  },
}))

export const fetchAllRequest = () => ({
  type: types.ORGANIZATIONS_FETCH_ALL_REQUEST,
})

export const fetchAllSuccess = data => ({
  type: types.ORGANIZATIONS_FETCH_ALL_SUCCESS,
  payload: { data },
})

export const createOrganization = request('ORGANIZATIONS/CREATE', data => ({
  request: {
    url: '/organizations',
    method: 'POST',
    data: data.toJS ? data.toJS() : data,
  },
  form: ORGANIZATIONS_EDIT_FORM_NAME,
  success: 'Organization was successfully created!',
}))

export const fetchIdRequest = request('ORGANIZATIONS/FETCH_ID_REQUEST', (id, fromSettings) => {
  return {
    request: {
      url: `/organizations/${id}`,
      data: {
        id,
        fromSettings,
      },
    },
  }
})

export const updateOrganization = request('ORGANIZATIONS/UPDATE', data => ({
  request: {
    url: `/organizations/${data.get ? data.get('id') : data.id}`,
    method: 'PUT',
    data: data.toJS ? data.toJS() : data,
  },
  form: ORGANIZATIONS_EDIT_FORM_NAME,
  success: 'Organization was successfully updated!',
}))

export const checkDomain = createAction(types.ORGANIZATIONS_CHECK_DOMAIN_REQUEST, (domain, formName) => ({
  domain,
  formName,
}))

export const uploadLogoRequest = (file, mime, ext, fieldName) => ({
  type: types.ORGANIZATIONS_UPLOAD_LOGO_REQUEST,
  payload: { file, mime, ext, fieldName },
})

export const uploadLogoSuccess = url => ({
  type: types.ORGANIZATIONS_UPLOAD_LOGO_SUCCESS,
  payload: { url },
})

export const uploadLogoError = () => ({
  type: types.ORGANIZATIONS_UPLOAD_LOGO_ERROR,
})

export const selectPage = page => ({
  type: types.ORGANIZATIONS_SELECT_PAGE,
  payload: {
    page,
  },
})

export const sortBy = (by, desc) => ({
  type: types.ORGANIZATIONS_SORT_BY,
  payload: {
    by,
    desc,
  },
})

export const filterBy = by => ({
  type: types.ORGANIZATIONS_FILTER_BY,
  payload: {
    by,
  },
})

export const fetchUsersRequest = id => ({
  type: types.ORGANIZATIONS_FETCH_USERS_REQUEST,
  payload: { id },
})

export const fetchUsersSuccess = data => ({
  type: types.ORGANIZATIONS_FETCH_USERS_SUCCESS,
  payload: { data },
})

export const updateOrganizationUserRoles = request('ORGANIZATIONS/UPDATE_USER_ROLES', ({ organizationId, users }) => ({
  request: {
    url: `/organizations/${organizationId}/users/roles/bulk`,
    method: 'PUT',
    data: { users },
  },
  success: 'Roles updated successfully',
}))

export const getLoginLinkAsUser = createAction('ORGANIZATIONS/GET_LOGIN_LINK_AS_USER', payload => payload)

export const selectUsersPage = page => ({
  type: types.ORGANIZATIONS_USERS_SELECT_PAGE,
  payload: { page },
})

export const sortUsersBy = (by, desc) => ({
  type: types.ORGANIZATIONS_USERS_SORT_BY,
  payload: {
    by,
    desc,
  },
})

export const filterUsersBy = by => ({
  type: types.ORGANIZATIONS_USERS_FILTER_BY,
  payload: {
    by,
  },
})

export const filterUsersByTeam = team => ({
  type: types.ORGANIZATIONS_USERS_FILTER_BY_TEAM,
  payload: {
    team,
  },
})

export const switchUsersTab = tab => ({
  type: types.ORGANIZATIONS_USERS_SWITCH_TAB,
  payload: {
    tab,
  },
})

export const selectUsersOrganization = ({ id, title }) => ({
  type: types.ORGANIZATIONS_SELECT_USERS_ORGANIZATION,
  payload: {
    id,
    name: title,
  },
})

export const setFormType = type => ({
  type: types.ORGANIZATIONS_FORM_SET_FORM_TYPE,
  payload: {
    type,
  },
})

export const remoteSubmitForm = () => ({
  type: types.ORGANIZATIONS_REMOTE_FORM_SUBMIT,
})

export const enableOrganizationsForm = () => ({
  type: types.ORGANIZATIONS_FORM_ENABLE,
})

export const disableOrganizationsForm = () => ({
  type: types.ORGANIZATIONS_FORM_DISABLE,
})

export const selectFirstUsersOrganization = () => ({
  type: types.ORGANIZATIONS_USERS_SELECT_FIRST_ORGANIZATION,
})

export const invites = {
  post: createRequestActions({
    request: types.INVITES.POST.REQUEST,
    success: types.INVITES.POST.SUCCESS,
    fail: types.INVITES.POST.FAIL,
  }),
}

export const invitesFormSubmit = (values, isBulk) => ({
  type: types.INVITES_FORM_SUBMIT,
  payload: {
    values,
    isBulk,
  },
})

export const adminOrganizationUsers = {
  get: createRequestActions({
    request: types.ADMIN_ORGANIZATION_USERS.GET.REQUEST,
    success: types.ADMIN_ORGANIZATION_USERS.GET.SUCCESS,
    fail: types.ADMIN_ORGANIZATION_USERS.GET.FAIL,
  }),
  post: createRequestActions({
    request: types.ADMIN_ORGANIZATION_USERS.POST.REQUEST,
    success: types.ADMIN_ORGANIZATION_USERS.POST.SUCCESS,
    fail: types.ADMIN_ORGANIZATION_USERS.POST.FAIL,
  }),
}

export const adminOrganizationUsersResendInvite = {
  post: createRequestActions({
    request: types.ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.REQUEST,
    success: types.ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.SUCCESS,
    fail: types.ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.FAIL,
  }),
}

export const setOrganizationPendingGetOrganizationUsers = pending => ({
  type: types.ORGANIZATION_SET_PENDING_GET_ORGANIZATION_USERS,
  payload: {
    pending,
  },
})

export const createOneSignalApplication = request('ORGANIZATIONS/CREATE_ONE_SIGNAL_APPLICATION', id => ({
  request: {
    url: `/organizations/${id}/one-signal`,
    method: 'POST',
  },
}))

export const deleteOrganizationUser = request('ORGANIZATIONS/USERS/DELETE', ({ id, reason }) => ({
  request: {
    url: `/users/${id}`,
    method: 'DELETE',
    data: { reason },
  },
  success: 'User deleted successfully.',
}))

export const getUserProtracks = request('ORGANIZATIONS/USER_PROTRACKS/GET', userId => ({
  request: {
    url: `users/${userId}/protracks`,
  },
}))

export const getUserProtrackActivities = request('ORGANIZATIONS/USER_ACTIVITIES/GET', params => ({
  request: {
    url: `users/${params.userId}/protracks/${params.levelId}/activities`,
  },
}))

export const updateUserProtrackActivity = request('ORGANIZATIONS/USER_ACTIVITY/PUT', params => {
  const { userId, levelId, previousActionType, newActionType, reason, activityId } = params
  return {
    request: {
      url: `users/${userId}/protracks/${levelId}/activities/${activityId}`,
      method: 'PUT',
      data: {
        previousActionType,
        newActionType,
        reason,
      },
    },
  }
})

export const setOrganizationUsersFilter = createAction('ORGANIZATIONS/SET_USER_FILTER', value => ({ value }))

export const reinviteOrganizationUsers = request('ORGANIZATIONS/USERS_REINVITE/POST', emails => ({
  request: {
    url: `users/invitation-resend/bulk`,
    method: 'POST',
    data: { emails: emails },
  },
  success: res => `${get(res, 'data.emails.length')} users successfully reinvited.`,
}))

export const resendOrganizationUsersSelectProTrack = request(
  'ORGANIZATIONS/USERS_RESEND_SELECT_PROTRACK/POST',
  emails => ({
    request: {
      url: `users/select-protrack-resend/bulk`,
      method: 'POST',
      data: { emails: emails },
    },
    success: res => `Select ProTrack email sent to ${get(res, 'data.emails.length')} users.`,
  })
)

export const updateUserPhoneNumber = request('ORGANIZATIONS/USER_PHONE', data => ({
  request: {
    url: `users/${data.id}`,
    method: 'PUT',
    data: { phone: data.phone, phoneISO: data.phoneISO },
  },
  fail: "Updating user's phone number was failed",
  success: "Updating user's phone number was successfully",
}))

export const updateUserEmail = request('ORGANIZATIONS/USER_EMAIL', ({ userId, email }) => ({
  request: {
    url: `users/${userId}`,
    method: 'PUT',
    data: { email },
  },
  fail: "Updating user's email was failed",
  success: "Updating user's email was successfully",
}))

export const updateUserTeams = request('ORGANIZATIONS/USER_TEAMS', data => ({
  request: {
    url: `users/${data.id}`,
    method: 'PUT',
    data: { teams: data.teams },
    pendingObject: { teams: List(data.teams), userId: data.id, scope: data.scope },
  },
  fail: "Updating user's teams was failed",
  success: "Updating user's teams was successfully",
}))

export const updateUserTeamsSuccessForMicroactions = createAction(
  'ORGANIZATIONS/USER_TEAMS_SUCCESS_FOR_MICROACTIONS',
  data => data
)

export const updateUserTeamsSuccessForReviews = createAction(
  'ORGANIZATIONS/USER_TEAMS_SUCCESS_FOR_REVIEWS',
  data => data
)

export const updateOrganizationProtrackLevelTeams = request('ORGANIZATIONS/PROTRACK_LEVEL_TEAMS', data => {
  return {
    request: {
      url: `/organizations/${data.organizationId}/protrack-levels/${data.id}`,
      method: 'PUT',
      data: { teams: data.teams },
      pendingObject: {
        teams: List(data.teams),
        proTrackLevelId: data.id,
        organizationId: data.organizationId,
        scope: data.scope,
      },
    },
    fail: "Updating ProtrackLevel's teams was failed",
    success: "Updating ProtrackLevel's teams was successfully",
  }
})

export const updateOrganizationProtrackLevelTeamsSuccessForMicroactions = createAction(
  'ORGANIZATIONS/PROTRACK_LEVEL_TEAMS_SUCCESS_FOR_MICROACTIONS',
  data => data
)

export const updateUserNotificationTypes = request('ORGANIZATIONS/USER_UPDATE', data => ({
  request: {
    url: `users/${data.id}`,
    method: 'PUT',
    data: { notificationType: data.notificationTypes, browser: browserName },
    pendingObject: data.pendingObject,
  },
  fail: "Updating user's notification types was failed",
  success: "Updating user's notification types was successfully",
}))

export const fetchOrganizationById = request('ORGANIZATIONS/GET_ORG_BY_ID', organizationId => {
  return {
    request: {
      url: `organizations/${organizationId}`,
      pendingObject: { organizationId },
    },
  }
})

export const resendUserNotification = request('ORGANIZATIONS/RESEND_USER_NOTIFICATION', data => ({
  request: {
    url: `users/${data.id}/notification-resend`,
    method: 'POST',
    data: { type: data.type },
    pendingObject: data.pendingObject,
  },
  fail: "Resend user's notification was failed",
  success: "Resend user's notification was successfully",
}))

export const resendSurvey = request('ORGANIZATIONS/RESEND_SURVEY', data => ({
  request: {
    url: `users/${data.id}/resend-survey/${data.userProTrackLevelId}`,
    method: 'POST',
    data: { type: data.type },
    pendingObject: data.pendingObject,
  },
  fail: 'Resend survey was failed',
  success: 'Resend survey was successfully',
}))

export const setReviewsLinks = request('ORGANIZATION_SETTINGS/SET_SURVEY_LINKS', ({ links, organizationId }) => ({
  request: {
    url: `organizations/${organizationId}/reviews`,
    method: 'POST',
    data: { ...links },
  },
  helper: { organizationId, links },
  success: 'Successfully saved survey links',
}))

export const setPendingObject = createAction(types.ORGANIZATIONS_SET_PENDING_OBJECT, payload => payload)

export const fetchAvailableLanguages = createAction(types.FETCH_AVAILABLE_LANGUAGES, payload => payload)

export const setAvailableLanguages = createAction(types.SET_AVAILABLE_LANGUAGES, payload => payload)

export const fetchAvailableProTrackLevelsForSelectedOrg = request(
  'ORGANIZATIONS/USERS/FETCH_AVAILABLE_PROTRACKLEVELS_FOR_SELECTED_ORGANIZATION',
  orgId => {
    return {
      request: {
        url: `/organizations/${orgId}/protrack-levels`,
      },
    }
  }
)

// data is
// {
//   entireOrg: bool,
//   teams: [string],
//   proTrackLevelId: number,
//   emails: [string],
//   organizationId: number,
// }
export const manageProTrackLevels = createAction('ORGANIZATIONS/USERS/MANAGE_PROTRACKLEVELS', data => data)

export const fetchSwitchProTrackLevelsHistory = request(
  'ORGANIZATIONS/USERS/FETCH_PROTRACKLEVELS_HISTORY',
  organizationId => ({
    request: {
      url: `/protrack-levels-progress/${organizationId}/`,
    },
  })
)

export const fetchOrganizationProtrackLevelChanges = request(
  'ORGANIZATIONS/FETCH_ORGANIZATION_PROTRACK_LEVEL_CHANGES',
  organizationId => ({
    request: {
      url: `/organization-protrack-level-changes/${organizationId}`,
    },
  })
)

export const postPartnersLinks = request('ORGANIZATIONS/POST_PARTNERS_LINKS', ({ organizationId, data }) => ({
  request: {
    url: `/organizations/${organizationId}/partners-links`,
    method: 'POST',
    data,
  },
  success: 'Partners Promo Links were successfully saved!',
}))

export const toggleOrganizationSprints = request(
  'ORGANIZATIONS/TOGGLE_SPRINTS',
  ({ organizationId, isSprintsActive }) => ({
    request: {
      url: `/organizations/${organizationId}`,
      method: 'PATCH',
      data: { isSprintsActive },
    },
    success: `Sprints successfully ${isSprintsActive ? 'activated' : 'deactivated'}!`,
  })
)

export const createSprintForOrganization = request('ORGANIZATIONS/CREATE_SPRINT', ({ data, organizationId }) => {
  return {
    request: {
      url: `/organizations/${organizationId}/sprint`,
      method: 'POST',
      data,
    },
    success: 'Sprint successfully created!',
  }
})

export const updateSprintForOrganization = request('ORGANIZATIONS/UPDATE_SPRINT', ({ data, organizationId }) => {
  return {
    request: {
      url: `/organizations/${organizationId}/sprint/${data.id}`,
      method: 'PUT',
      data,
    },
    success: 'Sprint successfully updated!',
  }
})

export const fetchSprintById = request(
  'ORGANIZATIONS/FETCH_SPRINT_BY_ORGANIZATION_ID',
  ({ organizationId, sprintId }) => {
    return {
      request: {
        url: `/organizations/${organizationId}/sprint/${sprintId}`,
      },
    }
  }
)

export const deleteSprintById = request(
  'ORGANIZATIONS/DELETE_SPRINT_BY_ORGANIZATION_ID',
  ({ organizationId, sprintId }) => {
    return {
      request: {
        url: `/organizations/${organizationId}/sprint/${sprintId}`,
        method: 'DELETE',
        pendingObject: { organizationId, sprintId },
      },
      success: 'Sprint was successfully deleted!',
    }
  }
)
